module.exports = __webpack_public_path__ + "static/API-code-mobile-60c6d119abe0d57a20112ba33728cb9f.png";